<template>
  <div class="notify">
    <div class="title ft20 D1D1D1">告知函</div>
    <div class="search">
      <el-row :gutter="20" type="flex">
        <el-col :span="6">
          <el-select
            size="small"
            v-model="searchForm.state"
            clearable
            placeholder="请选择告知状态"
          >
            <el-option
              v-for="item in stateList"
              :key="item.dictCode"
              :label="item.dictValue"
              :value="item.dictCode"
            >
            </el-option> </el-select
        ></el-col>
        <el-col :span="6"
          ><el-date-picker
            v-model="searchForm.yearMonth"
            type="month"
            placeholder="选择月"
            size="small"
          ></el-date-picker
        ></el-col>
        <el-col :span="6"
          ><el-input
            v-model="searchForm.informCode"
            placeholder="请输入告知函编码"
            size="small"
          ></el-input
        ></el-col>
        <el-col :span="6">
          <el-button
            size="small"
            type="primary"
            icon="el-icon-refresh-right"
            @click="queryClick"
            >查询</el-button
          >
          <el-button
            size="small"
            type="primary"
            plain
            icon="el-icon-refresh-right"
            @click="resetClick"
            >重置</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="list">
      <el-table
        ref="customerId"
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        :data="list"
        :header-cell-style="configs.headerCellStyle"
        :cell-style="configs.cellStyle"
      >
        <el-table-column label="告知函编码" prop="informCode">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              @click="modalClick('view', scope.row)"
              >{{ scope.row.informCode }}</el-link
            >
          </template>
        </el-table-column>
        <el-table-column label="年月" prop="yearMonth"></el-table-column>
        <el-table-column
          label="状态"
          prop="state"
          :formatter="formatterFn"
        ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-link
              type="primary"
              :underline="false"
              @click="modalClick('confirm', scope.row)"
              >确认</el-link
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageing" v-if="total > 1">
      <el-pagination
        background
        layout="total,prev, pager, next"
        :total="total"
        :current-page.sync="params.pageNum"
        prev-text="上一页"
        next-text="下一页"
        @current-change="cahngePage"
      >
      </el-pagination>
    </div>
    <el-dialog destroy-on-close :title="modalConfig.title" :visible.sync="modalConfig.visible" :width="modalConfig.width" append-to-body @closed="handleClosed">
      <component :is="formName" :formConfig='formConfig' ref="modalForm" @getList='getList' @close='handleClose' @closed="handleClosed"/>
    </el-dialog>
  </div>
</template>

<script>
import { findPageByConditions, mdmdictdata } from "@/api/api";
import NotifyForm from "./components/NotifyForm.vue";
import NotifyFormConfirm from "./components/NotifyFormConfirm.vue";

export default {
  name: "notify",
  data() {
    return {
      stateList: [],
      searchForm: {
        state: "",
        yearMonth: "",
        informCode: "",
      },
      configs: {
        headerCellStyle: {
          textAlign: "center",
          fontSize: "13px",
          color: "#787878",
          background: "#F5F5F5",
        },
        cellStyle: {
          textAlign: "center",
          fontSize: "14px",
          color: "#1D1D1D",
          lineHeight: "24px",
        },
      },
      list: [],
      total: 0,
      params: {
        pageNum: 1,
        pageSize: 10,
      },
      loading: true,
      modalConfig: {
        title: '标题',
        visible: false,
        width: '500px'
      },
      formConfig: {},
      formName: "NotifyForm",
    };
  },
  components: {
    NotifyForm,
    NotifyFormConfirm
  },
  async mounted() {
    await this.mdmdictdatas();
    this.getList();
  },
  methods: {
    // 查询
    queryClick() {
      this.params = {
        ...this.params,
        ...this.searchForm,
        pageNum: 1,
      };
      this.getList();
    },
    // 重置
    resetClick() {
      this.searchForm = {
        state: "",
        yearMonth: "",
        informCode: "",
      };

      this.params = {
        pageNum: 1,
        pageSize: 10,
      };
      this.getList();
    },
    // 翻页
    cahngePage(p) {
      this.params.pageNum = p;
      this.getList();
    },
    // 获取列表
    getList() {
      this.loading = true;
      findPageByConditions(this.params).then((res) => {
        if (res.code == 200) {
          this.list = res.result.data;
          this.total = res.result.count;
        }
        this.loading = false;
      });
    },
    mdmdictdatas() {
      mdmdictdata({ dictTypeCode: "dms_inform_state" }).then((res) => {
        if (res.code == 200) {
          this.stateList = res.result;
        }
      });
    },
    // 翻译数据字典
    formatterFn(row, column, cellValue) {
      let text = this.stateList.find(
        (v) => v.dictCode === cellValue.toString()
      );
      if (text) {
        return text.dictValue;
      } else {
        return "";
      }
    },
    // 弹框
    modalClick(type, row) {
      if (type === 'view') {
        this.modalConfig.title = '月度费用审批额度告知函';
        this.modalConfig.visible = true;
        this.modalConfig.width = '1000px';

        this.formConfig = {
          code: type,
          row
        }
      } else {
        if (!row.phone) {
          this.$message.error('请联系管理员维护经销商联系方式')
          return false;
        }
        this.modalConfig.title = '';
        this.modalConfig.visible = true;
        this.formName = "NotifyFormConfirm"

        this.formConfig = {
          code: type,
          row
        }
      }
    },
    handleClosed() {
      this.modalConfig.visible = false;
      this.modalConfig = {
          title: '标题',
          visible: false,
          width: '500px'
        }
        this.formConfig = {}
        this.formName = "NotifyForm"
        console.log(1111)
    },
     handleClose() {
      this.modalConfig.visible = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.notify {
  height: 100%;
  box-shadow: 0 2px 12px 0 rgba($color: #000000, $alpha: 0.1);
  padding: 20px;
  box-sizing: border-box;

  .title {
    margin-bottom: 20px;
  }

  .search {
    margin-bottom: 20px;
  }

  .pageing {
    margin-top: 20px;
    text-align: center;
  }
}
</style>
